import { render, staticRenderFns } from "./DetailsCredentials.vue?vue&type=template&id=98d40158&scoped=true&"
import script from "./DetailsCredentials.vue?vue&type=script&lang=js&"
export * from "./DetailsCredentials.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCredentials.vue?vue&type=style&index=0&id=98d40158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d40158",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VChip,VCol,VIcon,VRow})
